import moment from 'moment';
import angular from 'angular';

import multiPickerTemplate from '../../../../components/assetpicker/asset.multi.picker.html';
import template from './tag.bulk.html';

const DATETIME = 'Datetime';
const DATE = 'Date';
const HYPERLINK = 'Hyperlink';
const TEXT = 'Text';
const INTEGER = 'Integer';
const DECIMAL = 'Decimal';

class TagBulkApplyController {
  constructor(
    $scope,
    $uibModal,
    $filter,
    EquipmentService,
    TimezoneService,
    gettextCatalog,
    appSettings,
    tagsService,
    $ngRedux,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.$filter = $filter;
    this.EquipmentService = EquipmentService;
    this.TimezoneService = TimezoneService;
    this.gettextCatalog = gettextCatalog;
    this.appSettings = appSettings;
    this.tagsService = tagsService;
    this.store = $ngRedux;

    this.loading = true;
    this.animationsEnabled = true;
    this.selectedTags = [];
    this.values = {};
    this.opened = {};
    this.focus = {};
    this.datetimedate = {};
    this.cachedAttrs = {};

    this.assets = []; //list of equipments to send to the database
    this.postRemoval = [];
    this.removeFlags = {};
    this.filteredAssetList = [];
    this.assetByPage = [];
    this.searchText = '';
    this.previousSearchText = '';

    this.assetPredicate = 'name';
    this.assetReverse = false;

    this.assetPage = 1;
    this.itemsPerPage = 5;
    this.maxSize = 3;

    this.onlyNumbersReg = /[0-9]+/;

    this.isAllSelected = false;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis)(this);

    this.EquipmentService.getAllTags().then(
      (response) => this.tagsFromResponse(response),
      (error) => {
        let errorMsg = this.errorFromResponse(error);

        this.onLoadErrorFlag = true;
        this.onLoadErrorText = errorMsg;
        this.loading = false;
      },
    );

    this.dateFormat = this.appSettings.GetDateFormat();
  }

  mapStateToThis(state) {
    const { attributes } = state;

    let readonly = [];
    if (attributes != null && attributes.secured != null && attributes.secured.readonly) {
      readonly = readonly.concat(attributes.secured.readonly);
    }

    return {
      readonlyAttributes: readonly,
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  // Populate tags from API
  tagsFromResponse(response) {
    const allTags = response.data.data;
    this.tags = allTags
      .filter((t) => t.key != null && this.readonlyAttributes.indexOf(t.key.toLowerCase()) === -1)
      .map((tag) => {
        if (tag.dataType === DATETIME) {
          const { min, max } = tag.range || {};

          if (min) tag.range.min = moment(min).toDate();
          if (max) tag.range.max = moment(max).toDate();
        }
        return tag;
      });

    this.loading = false;
  }

  // Error from API
  errorFromResponse(error) {
    let errorMsg = this.gettextCatalog.getString(
      'An error occurred while retrieving attribute information',
    );

    const {
      data: { message },
      status,
      statusText,
    } = error || {};

    if (status)
      errorMsg = `${
        message ? message : errorMsg
      } : ${status.toString()} - ${statusText.toString()}`;
    else errorMsg += this.gettextCatalog.getString('. Please try again later');
    return errorMsg;
  }

  //Sort filteredEquipmentList
  orderAssetList(predicate) {
    if (predicate === this.assetPredicate) {
      this.assetReverse = !this.assetReverse;
    } else {
      this.assetReverse = false;
    }
    this.assetPredicate = predicate;
    this.GTM_AssetsListChanged('attributesBulkApplyAssetsOrderChanged');
  }

  //applyFilter searchs the equipments[] for anything matching the search input.
  applyAssetFilter(event) {
    if (!event && this.previousSearchText === this.searchText) return;
    this.filteredAssetList = this.$filter('filter')(this.assets, this.searchText);
    this.previousSearchText = this.searchText;
    this.GTM_AssetsListChanged(event || 'attributesBulkApplyAssetsFiltered');
  }

  openAssets() {
    const assets = this.assets;
    const modalInstance = this.$uibModal.open({
      animation: this.animationsEnabled,
      template: multiPickerTemplate,
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        selectedAssets: function () {
          const selected = {};

          if (assets) {
            for (let i = 0; i < assets.length; i++) {
              let e = assets[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
        maxSelection: function () {
          return 0;
        },
      },
    });

    modalInstance.result.then((selectedAssets) => {
      this.assets = [];
      for (let key in selectedAssets.result) {
        this.assets.push(selectedAssets.result[key]);
      }
      this.cachedAttrs = {};
      this.cacheAttrs(selectedAssets.result);
      this.isAllSelected = false;
      this.applyAssetFilter('attributesBulkApplyAssetsChanged');
    });
  }

  selectAllAssets() {
    if (this.assets.length > 0) {
      this.assets.forEach((asset) => {
        this.removeFlags[asset.id] = this.isAllSelected;
      });
    }
    this.GTM_AssetsListChanged(
      this.isAllSelected
        ? 'attributesBulkApplyAssetsAllSelected'
        : 'attributesBulkApplyAssetsAllDeselected',
    );
  }

  removeAssets() {
    if (this.sending) {
      return;
    }
    const newList = [];
    this.assets.forEach((asset) => {
      if (!this.removeFlags[asset.id]) {
        newList.push(asset);
      }
    });
    this.assets = angular.copy(newList);
    this.removeFlags = {};
    this.applyAssetFilter('attributesBulkApplyAssetsSelectedRemoved');
  }

  parseTags(asset) {
    const toDisplay = [];
    for (let key in asset.attrs) {
      for (let j = 0; j < this.tags.length; j++) {
        const tag = this.tags[j];
        if (key.toLowerCase() === tag.key.toLowerCase()) {
          toDisplay.push({
            key: tag.key,
            value: asset.attrs[key],
            index: j,
            dataType: tag.dataType,
            id: tag.id,
          });
          break;
        }
      }
    }
    return toDisplay;
  }

  cacheAttrs(assets) {
    for (const key in assets) {
      this.cachedAttrs[key] = {};
      for (let attr in assets[key].attrs) {
        let found = false;
        for (let j = 0; j < this.tags.length; j++) {
          if (attr.toLowerCase() === this.tags[j].key.toLowerCase()) {
            found = true;
            break;
          }
        }
        if (!found) {
          this.cachedAttrs[key][attr] = assets[key].attrs[attr];
        }
      }
    }
  }

  appendTag(tag) {
    const { id, dataType, freeform, range } = tag;

    this.selectedTags.push(tag);
    this.values[id] = {
      tag: id,
    };

    if (dataType === DATE || dataType === DATETIME) {
      this.opened[id] = false;

      const result = this.getDateValue(range, freeform, dataType);

      this.values[id] = { ...result };

      if (result.maxValue || result.minValue) {
        this.values[id].value = result.maxValue ? result.maxValue : result.minValue;
        this.datetimedate[id] = this.values[id].value;
      }
    }

    tag.selected = true;
    this.newTag = undefined;
    this.focus[id] = true;
    this.GTM_TagsChanged('attributesBulkApplyAttributeAdded');
  }

  getDateValue(range = {}, freeform, dataType) {
    let dateValue = {
      value: moment().toDate(),
    };

    if (freeform) {
      return dateValue;
    } else {
      if (range.min) {
        const minRange = moment(range.min).toDate();
        dateValue.value = minRange;

        if (dataType === DATETIME) {
          dateValue.minValue = minRange;
        }
      }

      if (range.max) {
        const maxRange = moment(range.max).toDate();
        dateValue.value = maxRange;

        if (dataType === DATETIME) {
          dateValue.maxValue = maxRange;
        }
      }
    }
    return dateValue;
  }

  removeTag(index) {
    const selectedTag = this.selectedTags[index];
    selectedTag.selected = false;
    delete this.values[selectedTag.id];
    delete this.focus[selectedTag.id];
    this.selectedTags.splice(index, 1);
    this.GTM_TagsChanged('attributesBulkApplyAttributeRemoved');
  }

  filterSelected(tag) {
    if (tag.selected) {
      return false;
    } else {
      return true;
    }
  }

  roundInt(val) {
    if (val) {
      return Math.floor(val);
    }
  }

  open(index) {
    this.opened[index] = true;
  }

  datetimeValidCheck(id) {
    if (!this.datetimedate[id]) return false;
    const temp = moment(this.datetimedate[id]).toDate();
    const value = this.values[id].value;
    if (value) {
      temp.setHours(value.getHours());
      temp.setMinutes(value.getMinutes());
      temp.setSeconds(value.getSeconds());
    }

    const valueForId = this.values[id];
    return (
      (valueForId.minValue == null || temp >= valueForId.minValue) &&
      (valueForId.maxValue == null || temp <= valueForId.maxValue)
    );
  }

  checkAllDatetimes() {
    for (let selectedTag in this.selectedTags) {
      if (selectedTag.dataType === DATETIME && !selectedTag.freeform) {
        if (!this.datetimeValidCheck(selectedTag.id));
        return false;
      }
    }
    return true;
  }

  generateTooltip(tag) {
    return this.tagsService.generateTooltip(tag, this.dateFormat);
  }

  applyTags() {
    this.successFlag = false;

    if (
      this.sending ||
      this.$scope.bulkForm.$invalid ||
      !this.checkAllDatetimes() ||
      this.assets.length <= 0 ||
      !this.selectedTags.length
    ) {
      return;
    }

    this.sending = true;
    this.errorFlag = false;

    const newTags = {};
    for (let j = 0; j < this.selectedTags.length; j++) {
      const selectedTag = this.selectedTags[j];
      const selectedTagId = selectedTag.id;
      const selectedTagValue = this.values[selectedTagId].value;
      let toAdd = {
        key: selectedTag.key.substring(0, 1).toLowerCase() + selectedTag.key.substring(1),
      };
      switch (selectedTag.dataType) {
        case HYPERLINK:
        case TEXT:
        case INTEGER:
        case DECIMAL:
          toAdd.v = selectedTagValue;
          break;
        case DATE:
          toAdd.v = this.$filter('date')(selectedTagValue, 'yyyy-MM-dd');
          break;
        case DATETIME:
          if (typeof selectedTagValue === 'string') {
            toAdd.v = selectedTagValue;
          } else {
            toAdd.v = moment(this.datetimedate[selectedTagId]).set({
              hour: selectedTagValue.getHours(),
              minutes: selectedTagValue.getMinutes(),
              seconds: selectedTagValue.getSeconds(),
              milliseconds: 0,
            });
          }
          break;
      }
      newTags[toAdd.key] = toAdd.v;
    }

    const changeset = [];
    const submitAssets = angular.copy(this.assets);
    for (let i = 0; i < submitAssets.length; i++) {
      const asset = submitAssets[i] || {};

      for (let tag in newTags) {
        asset.attrs[tag] = newTags[tag];
      }

      for (let cached in this.cachedAttrs[asset.id]) {
        asset.attrs[cached] = this.cachedAttrs[asset.id][cached];
      }

      const toAdd = {
        id: asset.id,
        op: 'overwrite',
        values: asset.attrs,
      };

      changeset.push(toAdd);
    }

    this.EquipmentService.batchPatchAttrs(changeset).then(
      (response) => {
        this.isEditing = false;
        this.sending = false;
        this.successFlag = true;
        this.assets = response.data;
        this.applyAssetFilter('attributesBulkApplyAssetsApplied');
        this.removeFlags = {};
      },
      (error) => {
        let errorMsg = this.errorFromResponse(error);

        this.errorFlag = true;
        this.errorText = errorMsg;
        this.sending = false;
      },
    );
  }

  toggleRemoval(asset) {
    this.applyAssetFilter(
      this.removeFlags[asset.id]
        ? 'attributesBulkApplyAssetSelected'
        : 'attributesBulkApplyAssetDeselected',
    );
  }

  GTM_TagsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.selectedTags.length,
      },
    });
  }

  GTM_AssetsListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.assets.length,
        totalFiltered: this.filteredAssetList.length,
        totalSelected: this.assets.filter((asset) => this.removeFlags[asset.id]).length,
        pageNumber: this.assetPage,
        sortDirection: this.assetReverse ? 'descending' : 'ascending',
      },
    });
  }
}

export const TagBulkApplyComponent = {
  template: template,
  controller: TagBulkApplyController,
  controllerAs: 'vm',
  bindings: {},
};
